import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { SEO } from '../components/SEO';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20
    }
  }
};
export function TermsPage() {
  return <div className="min-h-screen bg-white" data-id="element-611">
      <SEO title="Terms of Service" description="4ALL AI terms of service. Read the terms and conditions for using our free AI tool directory." canonicalPath="/terms" data-id="element-612" />
      <Header data-id="element-613" />

      <main className="w-full pb-24" data-id="element-614">
        <motion.section className="max-w-3xl mx-auto px-6 pt-24 pb-16" variants={containerVariants} initial="hidden" animate="visible" data-id="element-615">
          <motion.div variants={itemVariants} className="mb-16" data-id="element-616">
            <h1 className="text-5xl md:text-6xl font-bold text-black mb-6 tracking-tight" data-id="element-617">
              Terms of Service
            </h1>
            <p className="text-xl text-grey-500" data-id="element-618">
              Last updated: March 28, 2026
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="prose prose-lg max-w-none text-grey-700 space-y-12" data-id="element-619">
            <section data-id="element-620">
              <p className="text-lg leading-relaxed" data-id="element-621">
                Welcome to 4ALL, built by Skeuomorphic xyz. By accessing or
                using our platform, you agree to be bound by these Terms of
                Service. Please read them carefully.
              </p>
            </section>

            <section data-id="element-622">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-623">
                1. Acceptance of Terms
              </h2>
              <p className="leading-relaxed" data-id="element-624">
                By using 4ALL, you agree to these terms. If you don't agree to
                any part of these terms, you may not access the service. We
                reserve the right to update or modify these terms at any time
                without prior notice.
              </p>
            </section>

            <section data-id="element-625">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-626">
                2. Description of Service
              </h2>
              <p className="leading-relaxed" data-id="element-627">
                4ALL is a free AI tool discovery and curation platform. We
                provide summaries, categorizations, and links to third-party
                artificial intelligence tools to help users find solutions that
                fit their needs.
              </p>
            </section>

            <section data-id="element-628">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-629">
                3. Use of the Platform
              </h2>
              <p className="mb-4" data-id="element-630">
                You agree to use 4ALL only for lawful purposes and in a way that
                does not infringe the rights of, restrict, or inhibit anyone
                else's use and enjoyment of the platform. You must not:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-631">
                <li data-id="element-632">Attempt to gain unauthorized access to our systems</li>
                <li data-id="element-633">Use the platform to distribute malicious code or spam</li>
                <li data-id="element-634">
                  Scrape or extract data from our platform without permission
                </li>
              </ul>
            </section>

            <section data-id="element-635">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-636">
                4. Third-Party Tools and Links
              </h2>
              <p className="leading-relaxed" data-id="element-637">
                4ALL curates and links to external AI tools and services. We do
                not own, operate, or control these third-party tools. Your use
                of any third-party tool is subject to that tool's own terms of
                service and privacy policy. We are not responsible for the
                availability, accuracy, or content of these external sites.
              </p>
            </section>

            <section data-id="element-638">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-639">
                5. Intellectual Property
              </h2>
              <p className="leading-relaxed" data-id="element-640">
                The content, organization, graphics, design, and other matters
                related to 4ALL are protected under applicable copyrights and
                trademarks. The copying, redistribution, use, or publication by
                you of any such matters or any part of the platform is strictly
                prohibited.
              </p>
            </section>

            <section data-id="element-641">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-642">
                6. Disclaimer of Warranties
              </h2>
              <p className="leading-relaxed" data-id="element-643">
                While we strive to curate high-quality tools, 4ALL is provided
                on an "as is" and "as available" basis. We make no warranties,
                expressed or implied, regarding the operation of the platform or
                the information, content, materials, or products included on it.
                We do not guarantee the quality, safety, or legality of any
                third-party tools we link to.
              </p>
            </section>

            <section data-id="element-644">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-645">
                7. Limitation of Liability
              </h2>
              <p className="leading-relaxed" data-id="element-646">
                Skeuomorphic xyz and 4ALL shall not be liable for any direct,
                indirect, incidental, special, or consequential damages
                resulting from the use or inability to use our platform or any
                third-party tools discovered through our platform.
              </p>
            </section>

            <section data-id="element-647">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-648">
                8. Changes to Terms
              </h2>
              <p className="leading-relaxed" data-id="element-649">
                We reserve the right to modify these terms at any time. We will
                notify users of any significant changes by updating the "Last
                updated" date at the top of this page. Your continued use of the
                platform following any changes indicates your acceptance of the
                new terms.
              </p>
            </section>

            <section data-id="element-650">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-651">
                9. Governing Law
              </h2>
              <p className="leading-relaxed" data-id="element-652">
                These terms shall be governed by and construed in accordance
                with the laws of the jurisdiction in which Skeuomorphic xyz
                operates, without regard to its conflict of law provisions.
              </p>
            </section>

            <section data-id="element-653">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-654">
                10. Contact Information
              </h2>
              <p className="leading-relaxed" data-id="element-655">
                If you have any questions about these Terms of Service, please
                contact us at terms@skeuomorphic.xyz.
              </p>
            </section>
          </motion.div>
        </motion.section>
      </main>

      {/* Footer */}
      <footer className="border-t border-grey-200" data-id="element-656">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8" data-id="element-657">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-grey-500" data-id="element-658">
            <p className="text-center sm:text-left" data-id="element-659">
              © 2026 4ALL AI | All Rights Reserved by Skeuomorphic xyz
            </p>
            <div className="flex items-center gap-6" data-id="element-660">
              <Link to="/privacy" className="hover:text-black transition-colors" data-id="element-661">
                Privacy
              </Link>
              <Link to="/terms" className="hover:text-black transition-colors" data-id="element-662">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}